import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import ClassCard from "../../components/ClassCard";
import Loader from "../../components/Loader";
import Api from "../../services/api.service";
import { ClassResponse } from "../../services/api.response.service";

const ClassBundles = () => {
  const [items, setItems] = useState<ClassResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    Api.getClassBundles()
      .then((res) => {
        const raw = res?.data?.data ?? res?.data ?? [];
        const list = Array.isArray(raw) ? raw : [];
        setItems(list);
      })
      .catch(() => {
        setError("Unable to load class bundles.");
        setItems([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="content-page scroller-hide">
      <Row className="d-flex flex-column gap-4">
        <h1 style={{ fontSize: "24px", fontWeight: 400 }}>
          Class Bundles
        </h1>

        {loading ? (
          <Loader noCard imageLoader />
        ) : error ? (
          <p className="text-muted">{error}</p>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
            {items.map((item, index) => (
              <div key={item.id ? `${item.id}-${index}` : index}>
                <ClassCard data={item} classBundles />
              </div>
            ))}
          </div>
        )}
      </Row>
    </div>
  );
};

export default ClassBundles;
